import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "relative w-5/12 h-screen flex flex-col justify-between bg-white" }
const _hoisted_3 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_4 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_5 = { class: "font-semibold text-20px mr-4" }
const _hoisted_6 = { class: "px-8 py-4 overflow-auto h-screen pb-32" }
const _hoisted_7 = { class: "text-12px xxl:text-14px text-gray-lp-500" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" bulk booking ")
const _hoisted_11 = { class: "w-full z-20 absolute bottom-0 items-center flex flex-row rounded-b-md text-xs bg-gray-lp-700 justify-end px-8 py-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Select = _resolveComponent("Select")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["justify-end items-center flex fixed inset-0 z-40 outline-none focus:outline-none", {'pb-4': _ctx.isShowRunningText}]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("bulkBooking.create.uploadFileTitle")), 1),
                _createVNode("img", {
                  src: _imports_0,
                  class: "w-4 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                  alt: "x"
                })
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t("bulkBooking.create.hintSection1")) + " ", 1),
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("bulkBooking.create.hintSection2")) + " ", 1),
                _hoisted_9,
                _hoisted_10,
                _createVNode("span", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToBulkDownload && _ctx.goToBulkDownload(...args))),
                  class: "text-red-lp-100 cursor-pointer hover:underline"
                }, _toDisplayString(_ctx.$t("bulkBooking.create.hintSection3")), 1)
              ]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bulkBooking.create.fileType'),
                class: "w-1/2 mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    placeholder: _ctx.$t('bulkBooking.create.fileType'),
                    modelValue: _ctx.form.type,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.type = $event)),
                    disabled: true
                  }, null, 8, ["placeholder", "modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bulkBooking.create.clientNameTitle'),
                class: "w-1/2 mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectSearch, {
                    onFilter: _ctx.fetchPosClient,
                    options: _ctx.posClientList,
                    isLoading: _ctx.isLoadingPosClient,
                    keyName: "name",
                    isShowErrorIndicator: _ctx.form.clientName.isBanned,
                    errorCaption: _ctx.$t('bulkBooking.create.errorClient'),
                    keyValue: "id",
                    modelValue: _ctx.form.clientName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.clientName = $event)),
                    placeholder: _ctx.$t('bulkBooking.create.clientNamePlaceholder')
                  }, null, 8, ["onFilter", "options", "isLoading", "isShowErrorIndicator", "errorCaption", "modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: "Template Format",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Select, {
                    class: "w-56",
                    onOpenSelect: _ctx.onOpenSelectTemplate,
                    onCloseSelect: _ctx.onCloseSelectTemplate,
                    isOpenMenu: _ctx.isOpenSelectTemplate,
                    value: _ctx.form.formatTemplate,
                    onChooseSelect: _ctx.onSelectTemplate,
                    dataSelect: _ctx.listTemplate
                  }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bulkBooking.create.activityName'),
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.form.activityName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.activityName = $event)),
                    placeholder: _ctx.$t('bulkBooking.create.placeholderActivityName'),
                    maxLength: "56",
                    "show-max-length": ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bulkBooking.create.attachment'),
                class: "my-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadFile, {
                    modelValue: _ctx.form.archiveFile,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.archiveFile = $event)),
                    isClear: _ctx.isClearFile,
                    "onUpdate:isClear": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isClearFile = $event)),
                    type: "xlsx",
                    maxRows: _ctx.maxRow,
                    isDraggable: false
                  }, null, 8, ["modelValue", "isClear", "maxRows"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_button_outline, {
              custom: "bg-white px-12 border border-red-lp-100 text-red-lp-200 mr-4",
              title: "Cancel",
              onClick: _ctx.onClose
            }, null, 8, ["onClick"]),
            _createVNode(_component_button_fill, {
              custom: "px-12 bg-red-lp-200",
              title: "Upload",
              isDisabled: _ctx.isDisabled,
              onClick: _ctx._onAdd
            }, null, 8, ["isDisabled", "onClick"])
          ])
        ])
      ], 2),
      _hoisted_12
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: _ctx.$t('bulkBooking.create.successBookingTitle'),
      onSubmit: _ctx.onCloseUploadBulkBooking,
      message: _ctx.$t('bulkBooking.create.successBookingMessage'),
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["title", "onSubmit", "message"]), [
      [_vShow, _ctx.resultUpload === 'success' || _ctx.resultUpload === 'uploading']
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: _ctx.$t('bulkBooking.create.successBookingTitle'),
      onSubmit: _ctx.onCloseUploadBulkBooking,
      message: _ctx.$t('bulkBooking.create.errorPartial'),
      image: "image-modal-warning",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["title", "onSubmit", "message"]), [
      [_vShow, _ctx.resultUpload === 'partially']
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: _ctx.$t('bulkBooking.create.failedBookingTitle'),
      onSubmit: _ctx.onCloseUploadBulkBooking,
      message: _ctx.$t('bulkBooking.create.failedBookingMessage'),
      image: "image-modal-failed",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["title", "onSubmit", "message"]), [
      [_vShow, _ctx.resultUpload === 'failed']
    ]),
    (_ctx.isUploadFailed)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          onTryAgain: _ctx._onAdd,
          onCancel: _ctx.onCloseErrorUpload,
          modal: "",
          errorType: _ctx.resultUpload
        }, null, 8, ["onTryAgain", "onCancel", "errorType"]))
      : _createCommentVNode("", true)
  ], 64))
}